import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import CashCutReport from "../../components/conciliacionCashCutReport";
import Layout from "../../components/layout";
import * as reportsActions from "../../actions/reports";
import IAction from "../../../types/IAction";

interface Props {
  pdfCashCut: (data: object, clubId: string, fechaDePago: string) => IAction;
}

class ConciliacionCashCut extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Box Cut" />
        <Layout>
          <CashCutReport pdfCashCut={this.props.pdfCashCut} />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  pdfCashCut: (data: object, clubId: string, fechaDePago: string) => {
    return dispatch(reportsActions.pdfCashCut(data, clubId, fechaDePago));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConciliacionCashCut);
